
import { IInsuranceDetailsState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { InsuranceDetailsModel } from 'src/app/model/insurance-details.model';


export const loginState: IInsuranceDetailsState = {
  model: new InsuranceDetailsModel()
};

const reducer = createReducer(loginState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      model: payload
    };
  })
);

export function insuranceDetailsReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
